<script setup>
import PageNotFoundSvg from '@images/page-not-found.svg';
</script>

<template>
  <div
    alt="404"
    class="text-center"
  >
    <img
      :src="PageNotFoundSvg"
    >
    <h2 class="text-center fw-bold">404: Page not found.</h2>
    <div>
      If you believe this is an error, please raise an issue in the
      <a
        href="https://gitlab.com/gitlab-org/developer-relations/contributor-success/contributors-gitlab-com/-/issues/new?issuable_template=default"
        target="_blank"
      >contributors-gitlab-com issue tracker</a>.
    </div>
  </div>
</template>
